import React from 'react';
import {Redirect} from 'react-router-dom';
import {createRoutes} from '../@vf/utility/Utils';
import {administratorPagesConfig} from './administrators';
import {errorPagesConfigs} from './errorPages';
import {initialUrl} from '../shared/constants/AppConst';

const routeConfigs = [...errorPagesConfigs, ...administratorPagesConfig];

const routes = [
  ...createRoutes(routeConfigs),
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={initialUrl} />,
  },
  {
    component: () => <Redirect to='/error-pages/error-404' />,
  },
];

export default routes;
